type ElitePlansHeroStatusSkeletonProps = {
  showTenure?: boolean
  showPlusBanner?: boolean
  showLockInBanner?: boolean
}

export function ElitePlansHeroStatusSkeleton({
  showTenure = false,
  showPlusBanner = false,
  showLockInBanner = false
}: ElitePlansHeroStatusSkeletonProps) {
  return (
    <div
      className='mt-6 w-full animate-pulse'
      aria-busy='true'
      aria-label='Loading plan details'
    >
      {showTenure ? (
        <div className='space-y-3 text-left'>
          <div className='flex items-center gap-3'>
            <div className='h-px flex-1 bg-[color:var(--ep-ink-muted)] opacity-20' />
            <div className='h-3 w-28 rounded bg-[color:var(--ep-ink-muted)] opacity-25' />
            <div className='h-px flex-1 bg-[color:var(--ep-ink-muted)] opacity-20' />
          </div>
          <ElitePlansHeroTenureCardSkeleton />
          <ElitePlansHeroTenureCardSkeleton compact />
        </div>
      ) : null}

      <div className='mt-8 h-14 w-full rounded-xl bg-[color:var(--ep-ink-muted)] opacity-25' />
      <div className='mx-auto mt-4 h-3 w-3/4 rounded bg-[color:var(--ep-ink-muted)] opacity-20' />
      <div className='mx-auto mt-2 h-3 w-1/2 rounded bg-[color:var(--ep-ink-muted)] opacity-15' />

      {showLockInBanner ? (
        <div className='mt-6 w-full text-left'>
          <div className='mx-auto mb-4 h-3 w-40 rounded bg-[color:var(--ep-ink-muted)] opacity-20' />
          <div className='h-40 overflow-hidden rounded-xl bg-white/70' />
        </div>
      ) : null}

      {showPlusBanner ? (
        <div className='mt-6 w-full text-left'>
          <div className='mx-auto mb-4 h-3 w-40 rounded bg-[color:var(--ep-ink-muted)] opacity-20' />
          <div className='overflow-hidden rounded-3xl bg-white/70'>
            <div className='space-y-0 divide-y divide-[#EEECEC]'>
              <ElitePlansHeroPlusRowSkeleton />
              <ElitePlansHeroPlusRowSkeleton />
              <ElitePlansHeroPlusRowSkeleton />
            </div>
            <div className='h-12 border-t border-[#EEECEC] bg-transparent' />
          </div>
        </div>
      ) : null}
    </div>
  )
}

export function ElitePlansHeroTenureCardSkeleton({ compact = false }: { compact?: boolean }) {
  return (
    <div className='rounded-xl bg-white/80 px-4 py-[18px]'>
      <div className='flex items-center justify-between'>
        <div className='flex items-center gap-3'>
          <div className='size-5 rounded-full bg-[color:var(--ep-ink-muted)] opacity-25' />
          <div className='space-y-2'>
            <div className='h-3 w-16 rounded bg-[color:var(--ep-ink-muted)] opacity-25' />
            {compact ? null : (
              <div className='h-3 w-20 rounded bg-[color:var(--ep-ink-muted)] opacity-15' />
            )}
          </div>
        </div>
        <div className='space-y-2 text-right'>
          <div className='ml-auto h-3 w-24 rounded bg-[color:var(--ep-ink-muted)] opacity-25' />
          {compact ? null : (
            <div className='ml-auto h-3 w-16 rounded bg-[color:var(--ep-ink-muted)] opacity-15' />
          )}
        </div>
      </div>
    </div>
  )
}

export function ElitePlansHeroPlusRowSkeleton() {
  return (
    <div className='flex items-center justify-between gap-3 px-4 py-4'>
      <div className='space-y-2'>
        <div className='h-3 w-28 rounded bg-[color:var(--ep-ink-muted)] opacity-25' />
        <div className='h-3 w-40 rounded bg-[color:var(--ep-ink-muted)] opacity-15' />
      </div>
      <div className='h-3 w-16 rounded bg-[color:var(--ep-ink-muted)] opacity-20' />
    </div>
  )
}
